import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

/** The arrow a resting card carries; it answers the card's hover. */
export function CardArrow({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground transition-colors duration-300 group-hover:text-primary dark:bg-background',
        className
      )}
    >
      <ArrowRight className="size-4 transition-transform duration-300 group-hover:scale-125 rtl:rotate-180" />
    </span>
  )
}
